"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useUpdateSweepstakeOptionsMutation = exports.UpdateSweepstakeOptionsDocument = exports.useAgreedToSweepstakesRequirementsMutation = exports.AgreedToSweepstakesRequirementsDocument = exports.useRedrawSweepstakeWinnerMutation = exports.RedrawSweepstakeWinnerDocument = exports.useConfirmSweepstakeWinnerMutation = exports.ConfirmSweepstakeWinnerDocument = exports.useUpdateSweepstakeHistoryMutation = exports.UpdateSweepstakeHistoryDocument = exports.useFindSweepstakeWinnersLazyQuery = exports.useFindSweepstakeWinnersQuery = exports.FindSweepstakeWinnersDocument = exports.useFindSweepstakeEntryHistoryLazyQuery = exports.useFindSweepstakeEntryHistoryQuery = exports.FindSweepstakeEntryHistoryDocument = exports.useFindSweepstakeHistoryLazyQuery = exports.useFindSweepstakeHistoryQuery = exports.FindSweepstakeHistoryDocument = exports.useFindSweepstakeOptionStatsLazyQuery = exports.useFindSweepstakeOptionStatsQuery = exports.FindSweepstakeOptionStatsDocument = exports.useFindSweepstakeOptionsLazyQuery = exports.useFindSweepstakeOptionsQuery = exports.FindSweepstakeOptionsDocument = exports.useUpsertWinnerReactionMutation = exports.UpsertWinnerReactionDocument = exports.useUpsertSweepstakeEntriesMutation = exports.UpsertSweepstakeEntriesDocument = exports.useAllCurrentSweepstakeOptionsLazyQuery = exports.useAllCurrentSweepstakeOptionsQuery = exports.AllCurrentSweepstakeOptionsDocument = exports.useEmojiOptionsLazyQuery = exports.useEmojiOptionsQuery = exports.EmojiOptionsDocument = exports.useCurrentSweepstakeOptionsLazyQuery = exports.useCurrentSweepstakeOptionsQuery = exports.CurrentSweepstakeOptionsDocument = exports.SweepstakeEntryHistoryFragmentDoc = exports.SweepstakeHistoryFragmentDoc = exports.SweepstakeOptionsFragmentDoc = void 0;
const client_1 = require("@apollo/client");
const Apollo = __importStar(require("@apollo/client"));
const defaultOptions = {};
exports.SweepstakeOptionsFragmentDoc = client_1.gql `
    fragment SweepstakeOptions on SweepstakeOptions {
  id
  amountPerEntry
  estimatedValue
  special
  title
  subtitle
  icon
  quantity
  item
  endDate
  inactive
  hidden
  test
  created
  updated
}
    `;
exports.SweepstakeHistoryFragmentDoc = client_1.gql `
    fragment SweepstakeHistory on SweepstakeHistory {
  id
  optionsId
  winner
  confirmed
  uid
  entries
  paidEntries
  freeEntries
  deactivated
  deactivatedReason
  transactionCount
  created
  updated
}
    `;
exports.SweepstakeEntryHistoryFragmentDoc = client_1.gql `
    fragment SweepstakeEntryHistory on SweepstakeEntryHistory {
  ip
  source
  optionsId
  invoiceId
  uid
  email
  entries
  paidEntries
  freeEntries
  updatedXyoCollected
  created
  updated
}
    `;
exports.CurrentSweepstakeOptionsDocument = client_1.gql `
    query CurrentSweepstakeOptions {
  currentSweepstakeOptions {
    ...SweepstakeOptions
    userEntry {
      ...SweepstakeHistory
    }
  }
}
    ${exports.SweepstakeOptionsFragmentDoc}
${exports.SweepstakeHistoryFragmentDoc}`;
/**
 * __useCurrentSweepstakeOptionsQuery__
 *
 * To run a query within a React component, call `useCurrentSweepstakeOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCurrentSweepstakeOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCurrentSweepstakeOptionsQuery({
 *   variables: {
 *   },
 * });
 */
function useCurrentSweepstakeOptionsQuery(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useQuery(exports.CurrentSweepstakeOptionsDocument, options);
}
exports.useCurrentSweepstakeOptionsQuery = useCurrentSweepstakeOptionsQuery;
function useCurrentSweepstakeOptionsLazyQuery(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useLazyQuery(exports.CurrentSweepstakeOptionsDocument, options);
}
exports.useCurrentSweepstakeOptionsLazyQuery = useCurrentSweepstakeOptionsLazyQuery;
exports.EmojiOptionsDocument = client_1.gql `
    query EmojiOptions {
  emojiOptions {
    id
    icon
  }
}
    `;
/**
 * __useEmojiOptionsQuery__
 *
 * To run a query within a React component, call `useEmojiOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useEmojiOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEmojiOptionsQuery({
 *   variables: {
 *   },
 * });
 */
function useEmojiOptionsQuery(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useQuery(exports.EmojiOptionsDocument, options);
}
exports.useEmojiOptionsQuery = useEmojiOptionsQuery;
function useEmojiOptionsLazyQuery(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useLazyQuery(exports.EmojiOptionsDocument, options);
}
exports.useEmojiOptionsLazyQuery = useEmojiOptionsLazyQuery;
exports.AllCurrentSweepstakeOptionsDocument = client_1.gql `
    query AllCurrentSweepstakeOptions($special: Boolean) {
  allCurrentSweepstakeOptions(special: $special) {
    ...SweepstakeOptions
    blockhash
    userEntry {
      ...SweepstakeHistory
      reactions
    }
    winners {
      entries
      username
      confirmed
      profileImage
      videoUrl
      daysOld
      plan
    }
  }
}
    ${exports.SweepstakeOptionsFragmentDoc}
${exports.SweepstakeHistoryFragmentDoc}`;
/**
 * __useAllCurrentSweepstakeOptionsQuery__
 *
 * To run a query within a React component, call `useAllCurrentSweepstakeOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllCurrentSweepstakeOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllCurrentSweepstakeOptionsQuery({
 *   variables: {
 *      special: // value for 'special'
 *   },
 * });
 */
function useAllCurrentSweepstakeOptionsQuery(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useQuery(exports.AllCurrentSweepstakeOptionsDocument, options);
}
exports.useAllCurrentSweepstakeOptionsQuery = useAllCurrentSweepstakeOptionsQuery;
function useAllCurrentSweepstakeOptionsLazyQuery(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useLazyQuery(exports.AllCurrentSweepstakeOptionsDocument, options);
}
exports.useAllCurrentSweepstakeOptionsLazyQuery = useAllCurrentSweepstakeOptionsLazyQuery;
exports.UpsertSweepstakeEntriesDocument = client_1.gql `
    mutation UpsertSweepstakeEntries($id: ObjectId!, $entryCount: Int!, $source: String) {
  upsertSweepstakeEntries(id: $id, entryCount: $entryCount, source: $source) {
    ...SweepstakeOptions
    blockhash
    userEntry {
      ...SweepstakeHistory
    }
    winners {
      entries
      username
      confirmed
      profileImage
      videoUrl
      daysOld
      plan
    }
  }
}
    ${exports.SweepstakeOptionsFragmentDoc}
${exports.SweepstakeHistoryFragmentDoc}`;
/**
 * __useUpsertSweepstakeEntriesMutation__
 *
 * To run a mutation, you first call `useUpsertSweepstakeEntriesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertSweepstakeEntriesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertSweepstakeEntriesMutation, { data, loading, error }] = useUpsertSweepstakeEntriesMutation({
 *   variables: {
 *      id: // value for 'id'
 *      entryCount: // value for 'entryCount'
 *      source: // value for 'source'
 *   },
 * });
 */
function useUpsertSweepstakeEntriesMutation(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useMutation(exports.UpsertSweepstakeEntriesDocument, options);
}
exports.useUpsertSweepstakeEntriesMutation = useUpsertSweepstakeEntriesMutation;
exports.UpsertWinnerReactionDocument = client_1.gql `
    mutation UpsertWinnerReaction($id: ObjectId!, $emojiName: String!) {
  upsertWinnerReaction(id: $id, emojiName: $emojiName) {
    ...SweepstakeOptions
    userEntry {
      ...SweepstakeHistory
    }
  }
}
    ${exports.SweepstakeOptionsFragmentDoc}
${exports.SweepstakeHistoryFragmentDoc}`;
/**
 * __useUpsertWinnerReactionMutation__
 *
 * To run a mutation, you first call `useUpsertWinnerReactionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertWinnerReactionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertWinnerReactionMutation, { data, loading, error }] = useUpsertWinnerReactionMutation({
 *   variables: {
 *      id: // value for 'id'
 *      emojiName: // value for 'emojiName'
 *   },
 * });
 */
function useUpsertWinnerReactionMutation(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useMutation(exports.UpsertWinnerReactionDocument, options);
}
exports.useUpsertWinnerReactionMutation = useUpsertWinnerReactionMutation;
exports.FindSweepstakeOptionsDocument = client_1.gql `
    query findSweepstakeOptions($filter: SweepstakeOptionsFilter, $pagination: Pagination, $sort: Sort) {
  findSweepstakeOptions(filter: $filter, pagination: $pagination, sort: $sort) {
    total
    data {
      ...SweepstakeOptions
      winnerCount
      evergreen
      evergreenInterval
      evergreenDuration
      evergreenDrawingDate
      blockhash
      totalEntries
      winningEntries {
        historyId
        entry
        random
        attempt
        history {
          ...SweepstakeHistory
          username
          confirmed
          profileImage
          firstName
          lastName
          videoUrl
          daysOld
          plan
        }
      }
    }
  }
}
    ${exports.SweepstakeOptionsFragmentDoc}
${exports.SweepstakeHistoryFragmentDoc}`;
/**
 * __useFindSweepstakeOptionsQuery__
 *
 * To run a query within a React component, call `useFindSweepstakeOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindSweepstakeOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindSweepstakeOptionsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      pagination: // value for 'pagination'
 *      sort: // value for 'sort'
 *   },
 * });
 */
function useFindSweepstakeOptionsQuery(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useQuery(exports.FindSweepstakeOptionsDocument, options);
}
exports.useFindSweepstakeOptionsQuery = useFindSweepstakeOptionsQuery;
function useFindSweepstakeOptionsLazyQuery(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useLazyQuery(exports.FindSweepstakeOptionsDocument, options);
}
exports.useFindSweepstakeOptionsLazyQuery = useFindSweepstakeOptionsLazyQuery;
exports.FindSweepstakeOptionStatsDocument = client_1.gql `
    query findSweepstakeOptionStats($id: ObjectId!) {
  findSweepstakeOptionsById(id: $id) {
    ...SweepstakeOptions
    winnerCount
    evergreen
    evergreenInterval
    evergreenDuration
    evergreenDrawingDate
    blockhash
    totalEntries
    winningEntries {
      historyId
      entry
      random
      attempt
      history {
        ...SweepstakeHistory
        email
        username
        confirmed
        profileImage
        firstName
        lastName
        videoUrl
        daysOld
        plan
      }
    }
    redrawActions {
      data {
        action
        forUid
        forEmail
        forProfileImage
        byUid
        reason
        optionsId
        date
      }
    }
    stats {
      totalEntries
      participants
    }
  }
}
    ${exports.SweepstakeOptionsFragmentDoc}
${exports.SweepstakeHistoryFragmentDoc}`;
/**
 * __useFindSweepstakeOptionStatsQuery__
 *
 * To run a query within a React component, call `useFindSweepstakeOptionStatsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindSweepstakeOptionStatsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindSweepstakeOptionStatsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
function useFindSweepstakeOptionStatsQuery(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useQuery(exports.FindSweepstakeOptionStatsDocument, options);
}
exports.useFindSweepstakeOptionStatsQuery = useFindSweepstakeOptionStatsQuery;
function useFindSweepstakeOptionStatsLazyQuery(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useLazyQuery(exports.FindSweepstakeOptionStatsDocument, options);
}
exports.useFindSweepstakeOptionStatsLazyQuery = useFindSweepstakeOptionStatsLazyQuery;
exports.FindSweepstakeHistoryDocument = client_1.gql `
    query findSweepstakeHistory($filter: SweepstakeHistoryFilter, $pagination: Pagination, $sort: Sort) {
  findSweepstakeHistorys(filter: $filter, pagination: $pagination, sort: $sort) {
    total
    data {
      ...SweepstakeHistory
      email
      username
      confirmed
      profileImage
      videoUrl
      daysOld
      plan
    }
  }
}
    ${exports.SweepstakeHistoryFragmentDoc}`;
/**
 * __useFindSweepstakeHistoryQuery__
 *
 * To run a query within a React component, call `useFindSweepstakeHistoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindSweepstakeHistoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindSweepstakeHistoryQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      pagination: // value for 'pagination'
 *      sort: // value for 'sort'
 *   },
 * });
 */
function useFindSweepstakeHistoryQuery(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useQuery(exports.FindSweepstakeHistoryDocument, options);
}
exports.useFindSweepstakeHistoryQuery = useFindSweepstakeHistoryQuery;
function useFindSweepstakeHistoryLazyQuery(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useLazyQuery(exports.FindSweepstakeHistoryDocument, options);
}
exports.useFindSweepstakeHistoryLazyQuery = useFindSweepstakeHistoryLazyQuery;
exports.FindSweepstakeEntryHistoryDocument = client_1.gql `
    query findSweepstakeEntryHistory($filter: SweepstakeEntryHistoryFilter, $pagination: Pagination, $sort: Sort) {
  findSweepstakeEntryHistory(
    filter: $filter
    pagination: $pagination
    sort: $sort
  ) {
    total
    data {
      ...SweepstakeEntryHistory
      options {
        ...SweepstakeOptions
        blockhash
        userEntry {
          ...SweepstakeHistory
          reactions
        }
        winners {
          entries
          username
          confirmed
          profileImage
          firstName
          lastName
          videoUrl
          daysOld
          plan
        }
      }
    }
  }
}
    ${exports.SweepstakeEntryHistoryFragmentDoc}
${exports.SweepstakeOptionsFragmentDoc}
${exports.SweepstakeHistoryFragmentDoc}`;
/**
 * __useFindSweepstakeEntryHistoryQuery__
 *
 * To run a query within a React component, call `useFindSweepstakeEntryHistoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindSweepstakeEntryHistoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindSweepstakeEntryHistoryQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      pagination: // value for 'pagination'
 *      sort: // value for 'sort'
 *   },
 * });
 */
function useFindSweepstakeEntryHistoryQuery(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useQuery(exports.FindSweepstakeEntryHistoryDocument, options);
}
exports.useFindSweepstakeEntryHistoryQuery = useFindSweepstakeEntryHistoryQuery;
function useFindSweepstakeEntryHistoryLazyQuery(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useLazyQuery(exports.FindSweepstakeEntryHistoryDocument, options);
}
exports.useFindSweepstakeEntryHistoryLazyQuery = useFindSweepstakeEntryHistoryLazyQuery;
exports.FindSweepstakeWinnersDocument = client_1.gql `
    query findSweepstakeWinners($pagination: Pagination, $sort: Sort) {
  findSweepstakeWinners(pagination: $pagination, sort: $sort) {
    total
    data {
      ...SweepstakeHistory
      username
      profileImage
      videoUrl
      options {
        title
        subtitle
        icon
        quantity
        item
      }
    }
  }
}
    ${exports.SweepstakeHistoryFragmentDoc}`;
/**
 * __useFindSweepstakeWinnersQuery__
 *
 * To run a query within a React component, call `useFindSweepstakeWinnersQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindSweepstakeWinnersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindSweepstakeWinnersQuery({
 *   variables: {
 *      pagination: // value for 'pagination'
 *      sort: // value for 'sort'
 *   },
 * });
 */
function useFindSweepstakeWinnersQuery(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useQuery(exports.FindSweepstakeWinnersDocument, options);
}
exports.useFindSweepstakeWinnersQuery = useFindSweepstakeWinnersQuery;
function useFindSweepstakeWinnersLazyQuery(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useLazyQuery(exports.FindSweepstakeWinnersDocument, options);
}
exports.useFindSweepstakeWinnersLazyQuery = useFindSweepstakeWinnersLazyQuery;
exports.UpdateSweepstakeHistoryDocument = client_1.gql `
    mutation updateSweepstakeHistory($id: ObjectId!, $sweepstakeHistorySet: SweepstakeHistorySet!) {
  updateSweepstakeHistory(id: $id, sweepstakeHistorySet: $sweepstakeHistorySet) {
    ...SweepstakeHistory
    email
    username
    confirmed
    profileImage
    videoUrl
    firstName
    lastName
    daysOld
    plan
  }
}
    ${exports.SweepstakeHistoryFragmentDoc}`;
/**
 * __useUpdateSweepstakeHistoryMutation__
 *
 * To run a mutation, you first call `useUpdateSweepstakeHistoryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSweepstakeHistoryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSweepstakeHistoryMutation, { data, loading, error }] = useUpdateSweepstakeHistoryMutation({
 *   variables: {
 *      id: // value for 'id'
 *      sweepstakeHistorySet: // value for 'sweepstakeHistorySet'
 *   },
 * });
 */
function useUpdateSweepstakeHistoryMutation(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useMutation(exports.UpdateSweepstakeHistoryDocument, options);
}
exports.useUpdateSweepstakeHistoryMutation = useUpdateSweepstakeHistoryMutation;
exports.ConfirmSweepstakeWinnerDocument = client_1.gql `
    mutation confirmSweepstakeWinner($id: ObjectId!, $confirmed: Boolean!, $videoUrl: String!) {
  confirmSweepstakeWinner(id: $id, confirmed: $confirmed, videoUrl: $videoUrl) {
    ...SweepstakeHistory
    email
    username
    confirmed
    profileImage
    videoUrl
    firstName
    lastName
    daysOld
    plan
  }
}
    ${exports.SweepstakeHistoryFragmentDoc}`;
/**
 * __useConfirmSweepstakeWinnerMutation__
 *
 * To run a mutation, you first call `useConfirmSweepstakeWinnerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConfirmSweepstakeWinnerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [confirmSweepstakeWinnerMutation, { data, loading, error }] = useConfirmSweepstakeWinnerMutation({
 *   variables: {
 *      id: // value for 'id'
 *      confirmed: // value for 'confirmed'
 *      videoUrl: // value for 'videoUrl'
 *   },
 * });
 */
function useConfirmSweepstakeWinnerMutation(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useMutation(exports.ConfirmSweepstakeWinnerDocument, options);
}
exports.useConfirmSweepstakeWinnerMutation = useConfirmSweepstakeWinnerMutation;
exports.RedrawSweepstakeWinnerDocument = client_1.gql `
    mutation redrawSweepstakeWinner($id: ObjectId!, $redrawReason: String) {
  redrawSweepstakeWinner(id: $id, redrawReason: $redrawReason) {
    ...SweepstakeOptions
    winnerCount
    blockhash
    totalEntries
    winningEntries {
      historyId
      entry
      random
      attempt
      history {
        ...SweepstakeHistory
        email
        username
        confirmed
        profileImage
        videoUrl
        firstName
        lastName
        daysOld
        plan
      }
    }
    stats {
      totalEntries
      participants
    }
  }
}
    ${exports.SweepstakeOptionsFragmentDoc}
${exports.SweepstakeHistoryFragmentDoc}`;
/**
 * __useRedrawSweepstakeWinnerMutation__
 *
 * To run a mutation, you first call `useRedrawSweepstakeWinnerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRedrawSweepstakeWinnerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [redrawSweepstakeWinnerMutation, { data, loading, error }] = useRedrawSweepstakeWinnerMutation({
 *   variables: {
 *      id: // value for 'id'
 *      redrawReason: // value for 'redrawReason'
 *   },
 * });
 */
function useRedrawSweepstakeWinnerMutation(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useMutation(exports.RedrawSweepstakeWinnerDocument, options);
}
exports.useRedrawSweepstakeWinnerMutation = useRedrawSweepstakeWinnerMutation;
exports.AgreedToSweepstakesRequirementsDocument = client_1.gql `
    mutation agreedToSweepstakesRequirements($agreed: Boolean) {
  agreedToSweepstakesRequirements(agreed: $agreed)
}
    `;
/**
 * __useAgreedToSweepstakesRequirementsMutation__
 *
 * To run a mutation, you first call `useAgreedToSweepstakesRequirementsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAgreedToSweepstakesRequirementsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [agreedToSweepstakesRequirementsMutation, { data, loading, error }] = useAgreedToSweepstakesRequirementsMutation({
 *   variables: {
 *      agreed: // value for 'agreed'
 *   },
 * });
 */
function useAgreedToSweepstakesRequirementsMutation(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useMutation(exports.AgreedToSweepstakesRequirementsDocument, options);
}
exports.useAgreedToSweepstakesRequirementsMutation = useAgreedToSweepstakesRequirementsMutation;
exports.UpdateSweepstakeOptionsDocument = client_1.gql `
    mutation UpdateSweepstakeOptions($id: ObjectId!, $sweepstakeOptionsSet: SweepstakeOptionsSet) {
  updateSweepstakeOptions(id: $id, sweepstakeOptionsSet: $sweepstakeOptionsSet) {
    ...SweepstakeOptions
    winnerCount
    evergreen
    evergreenInterval
    evergreenDuration
    evergreenDrawingDate
    blockhash
    totalEntries
    winningEntries {
      historyId
      entry
      random
      attempt
      history {
        ...SweepstakeHistory
        email
        username
        confirmed
        profileImage
        videoUrl
        firstName
        lastName
        daysOld
        plan
      }
    }
    stats {
      totalEntries
      participants
    }
  }
}
    ${exports.SweepstakeOptionsFragmentDoc}
${exports.SweepstakeHistoryFragmentDoc}`;
/**
 * __useUpdateSweepstakeOptionsMutation__
 *
 * To run a mutation, you first call `useUpdateSweepstakeOptionsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSweepstakeOptionsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSweepstakeOptionsMutation, { data, loading, error }] = useUpdateSweepstakeOptionsMutation({
 *   variables: {
 *      id: // value for 'id'
 *      sweepstakeOptionsSet: // value for 'sweepstakeOptionsSet'
 *   },
 * });
 */
function useUpdateSweepstakeOptionsMutation(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useMutation(exports.UpdateSweepstakeOptionsDocument, options);
}
exports.useUpdateSweepstakeOptionsMutation = useUpdateSweepstakeOptionsMutation;
//# sourceMappingURL=client.generated.js.map